import { defineMessages } from "react-intl";

import { node as albumin } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/albumin";
import { node as alkalinePhosphatase } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/alkalinePhosphatase";
import { node as bilirubinDirect } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/bilirubinDirect";
import { node as bilirubinTotal } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/bilirubinTotal";
import { node as bnp } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/bnp";
import { node as coombsDirect } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/coombsDirect";
import { node as coombsIndirect } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/coombsIndirect";
import { node as creatinine } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/creatinine";
import { node as crp } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/crp";
import { node as fvs } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/fvs";
import { node as gfr } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/gfr";
import { node as ggt } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/ggt";
import { node as got } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/got";
import { node as gpt } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/gpt";
import { node as haemoglobin } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/haemoglobin";
import { node as hgbA1C } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/hgbA1C";
import { node as inr } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/inr";
import { node as karbamid } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/karbamid";
import { node as ldh } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/ldh";
import { node as natrium } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/natrium";
import { node as ntProBNP } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/ntProBnp";
import { node as plateletCount } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/plateletCount";
import { node as potassium } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/potassium";
import { node as prealbumin } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/prealbumin";
import { node as psa } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/psa";
import { node as pseudocholinesterase } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/pseudocholinesterase";
import { node as serumGlucose } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/serumGlucose";
import { node as t3 } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/t3";
import { node as t4 } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/t4";
import { node as tsh } from "src/modules/ltx/forms/phase-i/lab-procedures/standard-lab-procedures/tsh";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.standard_lab_procedures",
		defaultMessage: "Standard laborvizsgálatok"
	}
});

export const node: ParentNode = {
	id: "standardLabProcedures",
	value: { type: "list", title: messages.title, columns: 2 },
	children: [
		fvs,
		haemoglobin,
		plateletCount,
		gfr,
		creatinine,
		karbamid,
		natrium,
		potassium,
		got,
		gpt,
		ggt,
		alkalinePhosphatase,
		inr,
		prealbumin,
		pseudocholinesterase,
		bilirubinTotal,
		bilirubinDirect,
		ldh,
		serumGlucose,
		hgbA1C,
		crp,
		tsh,
		t3,
		t4,
		albumin,
		bnp,
		ntProBNP,
		coombsDirect,
		coombsIndirect,
		psa
	]
};
